import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound, Loader2 } from "lucide-react";
import MiniHeader from "@/components/site/MiniHeader";
import { ownerApi, apiErrorText } from "@/lib/ownerApi";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ next: "", confirm: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const token = params.get("token") || "";

  const submit = async (e) => {
    e.preventDefault();
    if (form.next.length < 8) return setError("Please use at least 8 characters.");
    if (form.next !== form.confirm) return setError("The two passwords don't match.");
    setSaving(true);
    try {
      await ownerApi.post("/auth/reset-password", { token, new_password: form.next });
      navigate("/owner", { replace: true, state: { notice: "Password updated. Sign in with your new password." } });
    } catch (err) {
      setError(apiErrorText(err));
    } finally {
      setSaving(false);
    }
  };

  const field = "w-full bg-transparent border border-[rgba(197,165,90,0.3)] rounded-md px-4 py-3 text-[#F5F0E8] placeholder:text-[#A0988E]/60 focus:outline-none focus:border-[#D4AF37]";
  return (
    <div data-testid="reset-password-page" className="min-h-screen">
      <MiniHeader />
      <main className="max-w-md mx-auto px-5 py-20">
        <div className="card-surface p-8">
          <KeyRound size={20} className="text-[#D4AF37]" />
          <h1 className="serif text-3xl text-[#F5F0E8] font-light mt-4">Choose a new password</h1>
          <form onSubmit={submit} className="mt-7 space-y-4">
            <input data-testid="reset-new-password-input" type="password" autoComplete="new-password" required placeholder="New password (at least 8 characters)"
                   value={form.next} onChange={(e) => { setForm({ ...form, next: e.target.value }); setError(""); }} className={field} />
            <input data-testid="reset-confirm-password-input" type="password" autoComplete="new-password" required placeholder="Type it again"
                   value={form.confirm} onChange={(e) => { setForm({ ...form, confirm: e.target.value }); setError(""); }} className={field} />
            {error && <p data-testid="reset-password-error" className="text-sm text-[#E6B89C]">{error}</p>}
            <button data-testid="reset-password-submit" disabled={saving || !token} className="btn-primary w-full justify-center disabled:opacity-60">
              {saving && <Loader2 size={16} className="animate-spin" />} Save new password
            </button>
            {!token && <p className="text-sm text-[#E6B89C]">This link is missing its code. Please use the link from your email.</p>}
          </form>
        </div>
      </main>
    </div>
  );
}
